module.exports.PageLinks = {
    about: "about-julian-wadden",
    general_enquiry: "general-enquiry",
    press_enquiry: "press-enquiry",
    news_insight: "news-and-insights",
    branch_finder: "branch-finder",
    area_cover: "area-guides",
    branch_contact: "contact",
    team_contact: "contact-us",
    teams: "meet-the-team",
    request_valuation: "request-valuation",
    privacy_policy: "https://ggfx-julianwadden2.s3.eu-west-2.amazonaws.com/i/Lomond_Privacy_Policy_Aug2025_3c52c2a6e4_c0efc3e616.pdf",
    terms_condition: "https://ggfx-julianwadden2.s3.eu-west-2.amazonaws.com/i/JW_Our_Agreement_Terms_Of_Business_Managed_Service_eaa99564a0.pdf",
    cookie_policy: "cookie-policy",
    book_a_viewing: "book-a-viewing",
    book_a_valuation: "request-a-valuation/home-visit-valuation",
    send_to_friend: "send-to-friend",
    property_to_rent: "property/to-rent",
    property_for_sale: "property/for-sale",
    default_property_url: "property/for-sale",
    reviews: "customer-reviews",
    property_management: "landlords/property-management",
    financial_services: "financial-services",
    online_payment: "online-payment",
    payment_success: "payment-success",
    payment_failed: "payment-failed",
    payment_verify: "online-payment-verification",
    our_brands: "our-brands",
    guides_resources: "guides-and-resources",
    contact_investment_centre: "contact-investment-centre",
    investment_centre: "investment-centre",
    international: "international-location",
    careers: "careers",
    current_vacancies: "careers/current-vacancies",
    job_details: "careers/job-details",
    case_study: "case-studies",
    furnishing_solutions: "furnishing-solutions",
    newhomes: "new-homes",
    sign_in: "myaccount/sign-in",
    videos: "videos",
    mortgage_advice: "mortgages",
    selling: "selling",
    renters_rights_act: "renters-rights-act",
    auction: "selling-at-auction"
}